import ReactQuill from 'react-quill';
import { cmsPrompt } from '../../components/CmsModal';

const Quill = ReactQuill.Quill;
const BlockEmbed = Quill.import('blots/block/embed');

class IframeEmbedBlot extends BlockEmbed {
  static create(value: { src: string; height?: string }) {
    let node = super.create();
    const height = value.height || '500';
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-src', value.src);
    node.setAttribute('data-height', height);

    node.innerHTML = `
      <div style="position: relative; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 16px rgba(0,0,0,0.08); border: 1px solid #E4E6EF;">
        <iframe 
          src="${value.src}" 
          width="100%" 
          height="${height}px" 
          style="border: none; display: block;" 
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen
        ></iframe>
      </div>
    `;
    node.style.margin = '24px 0';

    // Click-to-edit
    node.addEventListener('click', (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const currentSrc = node.getAttribute('data-src') || '';
      const currentHeight = node.getAttribute('data-height') || '500';

      cmsPrompt({
        title: 'Edit Embedded Content',
        description: 'Modify the iframe URL or height.',
        icon: 'bi bi-code-slash',
        fields: [
          { id: 'src', label: 'Embed URL', placeholder: 'e.g. https://www.youtube.com/embed/...', type: 'text', required: true, defaultValue: currentSrc },
          { id: 'height', label: 'Height (px)', placeholder: 'e.g. 500', type: 'text', required: false, defaultValue: currentHeight },
        ],
        submitText: 'Update Embed',
      }).then((values) => {
        if (!values) return;
        const { src, height: newHeight } = values;
        if (!src) return;
        const h = newHeight || '500';

        node.setAttribute('data-src', src);
        node.setAttribute('data-height', h);
        node.innerHTML = `
          <div style="position: relative; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 16px rgba(0,0,0,0.08); border: 1px solid #E4E6EF;">
            <iframe 
              src="${src}" 
              width="100%" 
              height="${h}px" 
              style="border: none; display: block;" 
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen
            ></iframe>
          </div>
        `;

        // Trigger Quill to recognize the change
        const qlContainer = node.closest('.ql-container');
        if (qlContainer) {
          const quillInstance = Quill.find(qlContainer);
          if (quillInstance) {
            quillInstance.update('user');
          }
        }
      });
    });

    return node;
  }

  static value(node: HTMLElement) {
    return {
      src: node.getAttribute('data-src') || '',
      height: node.getAttribute('data-height') || '500'
    };
  }
}
IframeEmbedBlot.blotName = 'iframeEmbed';
IframeEmbedBlot.tagName = 'div';
IframeEmbedBlot.className = 'ipf-iframe-embed-wrapper';

Quill.register(IframeEmbedBlot, true);

const icons = Quill.import('ui/icons');
icons['iframeEmbed'] = '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="14" height="12" rx="2"></rect><polyline points="5 8 7 6 5 4"></polyline><line x1="9" y1="8" x2="13" y2="8"></line></svg>';
